import {
  Component,
  HostBinding,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/servcies/localstorage-service';
import { Unicode } from 'src/shared/Endpoint';
import { Location } from '@angular/common';
import { DomainModel } from 'src/models/mongo/domain.model';
import { Utilities } from 'src/shared/utilities';
import { UserModel } from 'src/models/mongo/user.model';

@Component({
  selector: 'lib-customer-services',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './customer-services.component.html',
  styleUrls: ['./customer-services.component.scss'],
})
export class CustomerServicesComponent implements OnInit {
  @HostBinding('class') class = ' ';
  domain: DomainModel = new DomainModel();
  currentUser: UserModel;
  canEditCustomer: boolean;

  constructor(
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    private router: Router,
    private location: Location
  ) {}

  async ngOnInit(): Promise<void> {
    this.currentUser = this.localStorage.getLoggedinUserModel();
    this.canEditCustomer =
      !this.currentUser.isViewerOnly &&
      (this.currentUser.isSales ||
        this.currentUser.isOperations ||
        this.currentUser.isFinanceTeam);
    var paramsJson = this.localStorage.get(Unicode.CURRENT_CUSTOMER);
    if (paramsJson) {
      this.domain = JSON.parse(paramsJson);
    }
  }
  cancelOrder() {
    this.location.back();
  }
  editCustomer() {
    this.router.navigate(['customers/customer-create'], {
      state: { customerRfid: this.domain.customer_rfid },
      queryParams: {
        isCreationOrTransfer: !this.domain.is_transfer,
      },
    });
  }
}
